import { render, staticRenderFns } from "./message.pug?vue&type=template&id=3a495238&lang=pug&"
import script from "./message.ts?vue&type=script&lang=ts&"
export * from "./message.ts?vue&type=script&lang=ts&"
import style0 from "./message.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports